<template>
	<el-dialog
		class="customer_info_dialog"
		:class="{ 'is-mobile-dialog': isMobile }"
		:visible.sync="innerVisible"
		:width="isMobile ? '100%' : dialogWidth"
		:fullscreen="isMobile"
		:top="isMobile ? '0' : '8vh'"
		:append-to-body="true"
		:z-index="zIndex"
		@close="onClose"
		@update:visible="onVisible">
		<div class="customer_info_title" slot="title">{{ title }}</div>
		<el-form
			ref="customerInfoForm"
			:rules="rules"
			:label-position="isMobile ? 'top' : 'right'"
			:model="draft"
			class="customer_info_form">
			<el-row :gutter="24" class="quotation_info_row">
				<el-col :span="8">
					<el-form-item label="报价编号" prop="order_number">
						<el-input :readonly="readonly" class="field-full" placeholder="请输入" v-model="draft.order_number"></el-input>
					</el-form-item>
				</el-col>
				<el-col v-if="showSource" :span="8">
					<el-form-item label="客户来源">
						<el-select
							class="field-full"
							:value="customerSourceOwnerId"
							placeholder="选择账号"
							@change="$emit('source-change', $event)">
							<el-option label="我的客户" :value="0" />
							<el-option
								v-for="s in customerShareSources"
								:key="'src-' + s.owner_user_id"
								:label="(s.peer_nickname || s.peer_username || ('账号' + s.owner_user_id)) + '（共享）'"
								:value="Number(s.owner_user_id)" />
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="客户名称" prop="customer_id">
						<el-select
							ref="customerSelect"
							class="field-full"
							v-model="draft.customer_id"
							filterable
							clearable
							:placeholder="customerPlaceholder"
							popper-class="customer-select-dropdown"
							:filter-method="onFilter"
							@visible-change="$emit('select-visible', $event)"
							@change="$emit('customer-change', $event)">
							<el-option
								v-for="item in customerSelectOptions"
								:key="'c-' + item.id"
								:label="resolveOptionLabel(item)"
								:value="resolveOptionValue(item)">
							</el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="报价日期" prop="createTime">
						<el-date-picker
							value-format="yyyy-MM-dd"
							class="field-full field-date"
							:editable="editable"
							v-model="draft.createTime"
							type="date"
							placeholder="选择日期" />
					</el-form-item>
				</el-col>
			</el-row>
			<el-row :gutter="24" class="quotation_info_row quotation_info_row--bottom">
				<el-col :span="12">
					<el-form-item label="收货地址" prop="receiving_address" class="field-item-address">
						<el-input
							:clearable="clearable"
							class="field-full field-address"
							placeholder="请输入"
							resize="none"
							type="textarea"
							:rows="4"
							v-model="draft.receiving_address" />
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="联系人" prop="contacts">
						<el-input :clearable="clearable" class="field-full" placeholder="请输入" v-model="draft.contacts"></el-input>
					</el-form-item>
					<el-form-item label="联系电话" prop="contacts_phone">
						<el-input :clearable="clearable" class="field-full" placeholder="请输入" v-model="draft.contacts_phone"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>
		<div class="customer_info_footer">
			<el-button @click="$emit('cancel')">取消</el-button>
			<el-button type="primary" @click="$emit('confirm')">确定</el-button>
		</div>
	</el-dialog>
</template>

<script>
	export default {
		name: 'CustomerInfoDialog',
		props: {
			visible: { type: Boolean, default: false },
			isMobile: { type: Boolean, default: false },
			title: { type: String, default: '客户信息' },
			draft: { type: Object, required: true },
			rules: { type: Object, default: function() { return {} } },
			readonly: { type: Boolean, default: false },
			clearable: { type: Boolean, default: true },
			editable: { type: Boolean, default: true },
			customerSelectOptions: { type: Array, default: function() { return [] } },
			showSource: { type: Boolean, default: false },
			customerSourceOwnerId: { type: Number, default: 0 },
			customerShareSources: { type: Array, default: function() { return [] } },
			optionLabel: { type: Function, default: null },
			optionValue: { type: Function, default: null },
			customerPlaceholder: { type: String, default: '请输入客户名称搜索' },
			dialogWidth: { type: String, default: '980px' },
			zIndex: { type: Number, default: 4000 },
			filterMethod: { type: Function, default: null },
		},
		computed: {
			innerVisible: {
				get() { return this.visible },
				set(val) { this.$emit('update:visible', val) },
			},
		},
		methods: {
			onVisible(val) {
				this.$emit('update:visible', val)
			},
			onClose() {
				this.$emit('update:visible', false)
				this.$emit('close')
			},
			onFilter(query) {
				if (typeof this.filterMethod === 'function') this.filterMethod(query)
			},
			resolveOptionLabel(item) {
				if (typeof this.optionLabel === 'function') return this.optionLabel(item)
				return item.name
			},
			resolveOptionValue(item) {
				if (typeof this.optionValue === 'function') return this.optionValue(item)
				return item.id
			},
			getForm() {
				return this.$refs.customerInfoForm
			},
			getSelect() {
				return this.$refs.customerSelect
			},
		},
	}
</script>
